export const getPriorityIdByName = (text) => {

    if (text.toLowerCase().startsWith("h")) {
        return 3
    } else if (text.toLowerCase().startsWith("m")) {
        return 2
    } else if (text.toLowerCase().startsWith("l")) {
        return 1
    }
}